<div id="backgroundBanner">
    <div id="welcomeTextStyle">Welcome to MIRA</div>
</div>

<div id="loader"></div>